module.exports = __webpack_public_path__ + "static/media/6.f60e56c3.jpg";